/**
 * Typ dotazu
 */
export enum ResearchQueryType {
  /**
   * Uživatelský dotaz
   */
  QUERY = 'QUERY',

  /**
   * Periodická rešerše
   */
  PERIOD_QUERY = 'PERIOD_QUERY',

  /**
   * Textová analýza
   */
  TEXT_ANALYSIS = 'TEXT_ANALYSIS',
}
